import { SHARED_DEALS } from '../sharedConfig';

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'hempCbd',
  label: 'Hemp / CBD',
  strategySets: {
    default: {
      label: 'Standard (6 items)',
      lineItems: [
        { name: 'CPM_Broad_Hemp_HempResearchers_21plusonly_DIS_Awareness', segment: 'HEMP_RESEARCHERS', budgetAllocation: 25 },
        { name: 'CPM_Broad_Hemp_HempDelivery_21plusonly_DIS_Awareness', segment: 'HEMP_BUYERS_DELIVERY', budgetAllocation: 25 },
        { name: 'CPM_BT_SleepResearchers_x_WithSegments_DIS_Awareness', segment: 'SLEEP_RESEARCHERS', budgetAllocation: 15 },
        { name: 'CPM_BT_Cannabis&THC_x_WithSegments_DIS_Awareness', segment: 'CANNABIS_THC', budgetAllocation: 10 },
        { name: 'CPM_BT_StressResearchers_x_WithSegments_DIS_Awareness', segment: 'STRESS_RELIEF_RESEARCHERS', budgetAllocation: 15 },
        { name: 'CPM_BT_CannabisDeliveryResearchers_DeliveryReserchers_WithSegments_DIS_Awareness', segment: 'CANNABIS_DELIVERY', budgetAllocation: 10 },
      ],
    },
  },
  deals: SHARED_DEALS,
};
